import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults } from '../../styles/utils';
import '../../styles/global';
import { button } from '../button/styles';
import { cache } from '../utils';
var btnGapMap = {
  large: '8px',
  small: '4px',
  mini: '2px'
};
var iconFontSizeMap = {
  large: '18px',
  small: '16px',
  mini: '14px'
};
var sizes = ['large', 'small', 'mini'];
var defaults = deepDefaults({
  get fontSize() {
    return theme.default.fontSize;
  },
  gap: '16px',
  btn: {
    gap: '6px',
    padding: '0 3px',
    get borderRadius() {
      return theme.borderRadius;
    }
    // get hoverBgColor() { return theme.color.hoverBg }
  },
  // goto
  goto: {
    width: '60px',
    gap: '0 10px'
  }
}, sizes.reduce(function (memo, size) {
  var styles = theme[size];
  memo[size] = {
    get fontSize() {
      return styles.fontSize;
    },
    get btnGap() {
      return btnGapMap[size];
    },
    get iconFontSize() {
      return iconFontSizeMap[size];
    }
  };
  return memo;
}, {}));
var pagination;
setDefault(function () {
  pagination = deepDefaults(theme, {
    pagination: defaults
  }).pagination;
  makeStyles == null || makeStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("font-size:", pagination.fontSize, ";>*{display:inline-block;vertical-align:middle;&:not(:first-child){margin-left:", pagination.gap, ";}}.", k, "-pagination-ellipsis{background-color:transparent;border-color:transparent;}.", k, "-btns{.", k, "-btn{width:auto!important;min-width:", button.height, ";padding:", pagination.btn.padding, ";margin-right:", pagination.btn.gap, ";border-radius:", pagination.btn.borderRadius, "!important;&:last-of-type{margin:0!important;}}.", k, "-icon{font-size:18px;}}.", k, "-pagination-goto{.", k, "-input{font-size:inherit;width:", pagination.goto.width, ";margin:", pagination.goto.gap, ";}.", k, "-input-inner{text-align:center;}}.", k, "-select{width:auto;}", _mapInstanceProperty(sizes).call(sizes, function (size) {
    var styles = pagination[size];
    var btnStyles = button[size];
    return /*#__PURE__*/css("&.", k, "-", size, "{font-size:", styles.fontSize, ";.", k, "-btn{margin-right:", styles.btnGap, ";min-width:", btnStyles.height, ";.", k, "-icon{font-size:", styles.iconFontSize, ";}}}");
  }), "&.", k, "-flat{.", k, "-select{&,&:hover,&.", k, "-show{border-color:transparent;}}}&.", k, "-simple{.", k, "-btn{margin:0;}.", k, "-input-inner{text-align:center;}.", k, "-pagination-text{vertical-align:middle;}}");
});